/*
 * The behaviour that belongs to every page: opening the menu on a small screen, keeping the basket
 * count honest, and switching language. Every surface here already works without this file; this
 * only makes it quicker.
 */
(function () {
  'use strict';

  function bindDisclosure(toggleSelector, panelSelector, onOpen) {
    var toggle = document.querySelector(toggleSelector);
    var panel = document.querySelector(panelSelector);
    if (!toggle || !panel) return;

    function set(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && onOpen) onOpen(panel);
    }

    toggle.addEventListener('click', function () { set(panel.hidden); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        set(false);
        toggle.focus();
      }
    });
  }

  function bindMenu() {
    bindDisclosure('[data-menu-toggle]', '[data-menu-panel]');
    bindDisclosure('[data-search-toggle]', '[data-search-panel]', function (panel) {
      var input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }

  function bindLanguage() {
    var select = document.querySelector('[data-language-select]');
    if (!select || !select.form) return;
    select.addEventListener('change', function () { select.form.submit(); });
  }

  function bindCartCount() {
    document.addEventListener('hvo:cart-updated', function (event) {
      var count = event.detail && event.detail.itemCount;
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-cart-count]').forEach(function (node) {
        node.textContent = String(count);
        node.hidden = count === 0;
      });
    });
  }

  function bindPrivacyPreferences() {
    var button = document.querySelector('[data-cookie-preferences]');
    if (!button) return;

    button.addEventListener('click', function () {
      var fallbackUrl = button.getAttribute('data-fallback-url');
      var didNavigate = false;

      function navigateToFallback() {
        if (didNavigate || !fallbackUrl) return;
        didNavigate = true;
        window.location.assign(fallbackUrl);
      }

      try {
        if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
          navigateToFallback();
          return;
        }

        var result = window.privacyBanner.showPreferences();
        if (result && typeof result.then === 'function') {
          result.then(null, navigateToFallback);
        }
      } catch (error) {
        navigateToFallback();
      }
    });
  }

  function start() {
    bindMenu();
    bindLanguage();
    bindCartCount();
    bindPrivacyPreferences();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
